import { Avatar, DropdownMenu, Text } from "@nudgebox/ui";
import { CheckIcon, ChevronsUpDownIcon, PlusIcon } from "@nudgebox/ui/icons";
import "@nudgebox/ui/tokens.stylex";
import { color, fontSize, fontWeight, media, motion, radius, space } from "@nudgebox/ui/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { organizationsQuery } from "@/lib/queries.ts";
export function OrganizationSwitcher({
  currentSlug
}: {
  currentSlug: string;
}) {
  const {
    data: organizations
  } = useSuspenseQuery(organizationsQuery);
  const current = organizations.find(org => org.slug === currentSlug);
  return <DropdownMenu align="start" trigger={<button type="button" className="x78zum5 x6s0dn4 x1a62zme xh8yej3 xc9qbxq x8tjdam x1uu5im9 xc342km xoazux2 xjbqb8w x1b8pnsr x1enuzbz xxe3v3u x1ypdohk x1a2a7pz x15406qy x7updtu">
          <Avatar name={current?.name ?? currentSlug} src={current?.logo} size={22} square />
          <span className="x1iyjqo2 xdpxx8g xluwven x1ivwu1z x9aqtqa xb3r6kr xlyipyv xuxw1ft">{current?.name ?? currentSlug}</span>
          <ChevronsUpDownIcon size={14} />
        </button>} header={<Text size="xs" tone="tertiary">
          Organizations
        </Text>} items={[...organizations.map(org => ({
    label: org.name,
    icon: org.slug === currentSlug ? <CheckIcon size={14} /> : <span className="x6jxa94" />,
    render: <Link to="/$orgSlug" params={{
      orgSlug: org.slug
    }} />
  })), "separator" as const, {
    label: "Create organization",
    icon: <PlusIcon size={14} />,
    render: <Link to="/onboarding" />
  }]} />;
}